import { TopLeaguesRetriever } from "../TopLeaguesRetriever";
import { CouponLeaguesRetriever } from "../CouponLeaguesRetriever";
import { AllLeaguesRetriever } from "../AllLeaguesRetriever";
export class RetrieverChooser {
    constructor(bffGateway, dataProvider, loadedData) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.loadedData = loadedData;
    }
    selectRetriever(sportId = "0", leagueIds = []) {
        this.dataProvider.sportId = sportId;
        this.dataProvider.leagueIds = leagueIds;
        if (this.dataProvider.leagueIds.length) {
            return new CouponLeaguesRetriever(this.bff, this.dataProvider, this.loadedData);
        }
        if (this.dataProvider.isTopLeaguesOnly) {
            return new TopLeaguesRetriever(this.bff, this.dataProvider, this.loadedData);
        }
        return new AllLeaguesRetriever(this.bff, this.dataProvider, this.loadedData);
    }
}
//# sourceMappingURL=RetrieverChooser.js.map